import componentStyles from '@bridebook/web/app-basic/components/seo-links/seo-links.style';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { getSearchUrl } from '@bridebook/toolbox/src';
import { addCountryToSearchUrl } from '@bridebook/toolbox/src/add-country-to-search-url';
import { CountryCodes } from '@bridebook/toolbox/src/gazetteer';
import { A, Box, Pill } from '@bridebook/ui';
import { Link } from '@bridebook/web/app-shared/components/link/link';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { prettySupplierCategory } from '@bridebook/web/app-shared/lib/utils';
import { getI18n } from '@bridebook/web/lib/i18n/getI18n';

interface IProps {
  locations: string[];
  // text titles depend on type of location type e.g if county - use title 'Popular towns in {location}'
  locationType: string;
  location: string;
  topBorder: boolean;
  prettyCategory: string;
}

const SeoLinks = ({ locations, location, locationType, topBorder, prettyCategory }: IProps) => {
  const actualCategory = useSelector((state) => state.search.actualCategory);
  const market = useMarket();
  const styles = componentStyles(topBorder);

  // https://bridebook.atlassian.net/browse/LIVE-21564 French translation requires singular category
  prettyCategory = prettySupplierCategory({
    isLoggedIn: false,
    addWedding: true,
    amount: market.country === CountryCodes.FR ? 1 : 2,
    capitalize: true,
    slug: actualCategory,
    market,
  });

  const getEnhancedLocation = (location: string) => {
    if (actualCategory === 'venue' && market.country === CountryCodes.GB) {
      return enhancedLocation(location);
    }
    return location;
  };

  const locationHeader =
    locationType === 'county'
      ? popularTownsInLocation(location)
      : discoverSuppliersNearLocation(prettyCategory, location);
  return (
    <Box as="section" style={styles.wrapper}>
      <Box as="h2" style={styles.h2}>
        {locationHeader}
        {' ⭐️️  '}
      </Box>
      <Box style={styles.pillsWrapper}>
        {locations.map((location, index) => (
          <Link
            key={index}
            href={`/${market.prefix}${getSearchUrl({
              slug: actualCategory,
              area: addCountryToSearchUrl(location, market.country),
              as: true,
            })}`}
            legacyBehavior
            passHref>
            <A noUnderline>
              <Pill bordered sidePaddings={12} height={35} style={styles.pill}>
                {getEnhancedLocation(location)}
              </Pill>
            </A>
          </Link>
        ))}
      </Box>
    </Box>
  );
};

const popularTownsInLocation = (location: string) =>
  getI18n().t(`search:seoLinks.subTitle.popularTowns`, {
    location,
  });

const discoverSuppliersNearLocation = (category: string, location: string) =>
  getI18n().t(`search:seoLinks.subTitle.popularTownsNearTown`, {
    category,
    location,
  });

const enhancedLocation = (location: string) =>
  getI18n().t(`search:seoLinks.location.weddingVenues`, {
    location,
  });

export default SeoLinks;
